import './index.scss'
import '../../assets/scripts/myNiceScroll'
import {resizeScroll} from '../../assets/scripts/myNiceScroll'


// 查看更多
var videoListinitshowliNum = 4
var videoListshowstep = 2
var videoListclickNum = 0
var videoListtotalli = $('.video-list ul li').length

if (videoListtotalli <= 4) {
  $('.section2 .common-more-btn').hide()
}

$('.section2 .common-more-btn').on('click', function () {
  videoListclickNum += 1
  if (videoListinitshowliNum + videoListshowstep * videoListclickNum < videoListtotalli) {
    for (let i = 0; i < videoListshowstep; i++) {
      $('.video-list ul li').eq(videoListinitshowliNum + (videoListclickNum - 1) * videoListshowstep + i).show()
    }
  } else {
    for (let i = 0; i < videoListtotalli - videoListclickNum * videoListshowstep; i++) {
      $('.video-list ul li').eq(videoListinitshowliNum + (videoListclickNum - 1) * videoListshowstep + i).show()
    }
    $('.section2 .common-more-btn').hide()
  }
  resizeScroll()
})
